import { isSodimacStandalone, isTottusStandalone } from '@digital-retail/store-manager';
import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { useState } from 'react';
import AddToCartButton from '../../../../components/AddToCartButton/Desktop/AddToCartButtonDesktop';
import AddToCartButtonMobile from '../../../../components/AddToCartButton/Mobile/AddToCartButtonMobile';
import { AdditionalPDPLabel } from '../../../../components/AdditionalPDPLabel/AdditionalPDPLabel';
import { Badges } from '../../../../components/Badges/Badges';
import FloorCalculator from '../../../../components/FloorCalculator/FloorCalculator';
import InstallmentsWithoutInterest from '../../../../components/InstallmentsWithoutInterest/InstallmentsWithoutInterest';
import InternationalShipping from '../../../../components/InternationalShipping/InternationalShipping';
import MultipurposeBadge from '../../../../components/MultipurposeBadge/MultipurposeBadge';
import Operator from '../../../../components/Operator/Operator';
import { VariantId } from '../../../../components/PDP';
import ProductColorSwatches from '../../../../components/ProductColorSwatches/ProductColorSwatches';
import ProductPrices from '../../../../components/ProductPrices/ProductPrices';
import ProductTopSpecifications from '../../../../components/ProductTopSpecifications/ProductTopSpecifications';
import { ReaconditionedContainer } from '../../../../components/ReaconditionedContainer/ReaconditionedContainer';
import SellerInfo from '../../../../components/SellerInfo/SellerInfo';
import { ShippingDetails } from '../../../../components/ShippingDetails/ShippingDetails';
import Size from '../../../../components/Size/Size';
import StockQuantity from '../../../../components/StockQuantity/StockQuantity';
import StockTable from '../../../../components/ui/StockTable/StockTable';
import constants from '../../../../config/constants';
import { withApplicationContext } from '../../../../utils/ApplicationContext';
import { withLabels } from '../../../../utils/LabelsContext';
import _ from '../../../../utils/LodashImports';
import { withProduct } from '../../../../utils/ProductContext';
import { withUser } from '../../../../utils/UserContext';
import { useUserSegments } from '../../../../utils/hooks/useUserSegments';
import { noop } from '../../../../utils/noop';
import * as productUtils from '../../../../utils/product/productUtils';
import { getVariant } from '../../../../utils/variant';
import GenericCalculatorContainer from '../../../GenericCalculatorContainer/GenericCalculatorContainer';
import { SKUIdSeller } from '../../../common/PDPBasicInfoShared';
import { GetSharedDetails } from '../../shared';
import useInput from '../../useInput';
import { ProductSpecificationsMobileStyle } from './ProductSpecificationsMobile.style';

const { MAX_CART_PRODUCT, FIRST_PARTY_SELLER_REGEX, PRODUCT_CONSTANTS, VIEW_TEMPLATE, DEVICE_MOBILE } = constants;

const ProductSpecificationsMobile = ({
  product,
  labels,
  appCtx,
  isPumAvailable,
  pumQuantity,
  primeShipping,
  colorVariants,
  selectedColorSwatchIndex,
  colorSwatchHandler,
  sizes,
  selectedSize,
  sizeChangeHandler,
  handleAddToCart,
  isAddToCartInProgress,
  addToCartButtonVisible,
  handleRemoveFromCart,
  isRemoveFromCartInProgress,
  showCollectionButtonVisible,
  operators,
  operatorChangeHandler,
  setWarrantyOption,
  setServiceOption,
  isVendorLogin,
  storeSkuData,
  currentTab,
  selectedOperatorId,
  errorAddingToCart,
  requestProductFromStore,
  handleM2QuantityChange,
  m2Quantity,
  m2ResultValue,
  handleM2ResultChange,
  m2Value,
  handleM2ValueChange,
  isExtraM2Checked,
  handleExtraM2Change,
  m2AttributeValue,
  setShowLoginForm,
  showLoginForm,
  setErrorAddingToCart,
  sizeChartData,
  fomo,
  userSegments,
  isUserLoggedIn,
  variantSwatchType,
}) => {
  const { regionCode, deviceType, store, siteConfig, comuna: comunaData, isDefaultComuna } = appCtx || {};
  const { textDictionary, toggles } = siteConfig;
  const isMobile = deviceType === DEVICE_MOBILE;
  const isSoCom = isSodimacStandalone(store);
  const isTottusSA = isTottusStandalone(store);

  const {
    id: productId,
    currentVariant,
    variants,
    additionalPDPLabels,
    isOutOfStock,
    colorMetrics,
    darSectionActive = false,
    internationalShipping,
    attributes,
    productType,
    warrantyOptions,
    serviceOptions,
  } = product;

  const { viewTemplate, pumUnits } = attributes;
  const type = productType === PRODUCT_CONSTANTS.CONNECT ? PRODUCT_CONSTANTS.CONNECT : PRODUCT_CONSTANTS.HARDLINE;
  const shouldRenderSize = viewTemplate !== VIEW_TEMPLATE.TYPE_A && sizes.length > 0;
  const isConnectProduct = productUtils.isConnectProduct(product);
  const isReaconditionedProd = productUtils.isReaconditionedProduct(product);
  const isInternationalShipping = _.get(internationalShipping, 'applicable', false);

  const { currentUserSegments } = useUserSegments(regionCode, userSegments, isUserLoggedIn, appCtx?.store);

  const {
    badges = [],
    meatStickers = [],
    promotions,
    maxOnCartAmount = MAX_CART_PRODUCT,
    multipurposeBadges = [],
    prices,
    cmrPoints,
    discountBadge,
    comboData = null,
    offerings,
    availability,
    availabilityLabels = {},
  } = getVariant(variants, currentVariant);

  const {
    isMeatStickerApplicableInPDP = false,
    isMultipurposeBadgeApplicable = false,
    isStoreAvailabilityVisibleInPDP = false,
    isCMRCalculatorEnabledPDP = false,
    isWarrantyTooltipEnabled = false,
    isInternationalBuyVisiblePDP = false,
    isFloorcalculatorEnabled = true,
  } = toggles;

  const allowed3PCampaignNamesToRender = _.get(
    textDictionary,
    'ALLOWED_3P_CAMPAIGN_NAMES_TO_RENDER',
    'ENVIO GRATIS 3P, ENVIO_GRATIS_3P'
  );

  const freeShippingPromotionFor3p = promotions?.find((promotion) =>
    allowed3PCampaignNamesToRender
      .split(',')
      .map((name) => name.trim())
      .includes(promotion.campaignName)
  );

  const hasStickers = (isMeatStickerApplicableInPDP && meatStickers.length > 0) || freeShippingPromotionFor3p;
  const nonEventMeatStickers = (meatStickers || []).filter((sticker) => !['event'].includes(sticker.type));
  const sellerName = _.get(variants, '[0].offerings[0].sellerName', '');
  const is1pSeller = FIRST_PARTY_SELLER_REGEX.test(sellerName.toLowerCase());
  const sizeSelectionLabel = productUtils.getSizeSelectionLabel(product, labels.SELECTION_SIZE);
  const isStoreDataVaild = storeSkuData && Object.keys(storeSkuData).length > 0;
  const { showQuantityError, inputVal, handleInputChange, setQuantityError, setInputVal } = useInput(maxOnCartAmount);

  const addToCartLabel = _.get(additionalPDPLabels, 'addToCart.enabled', false)
    ? _.get(additionalPDPLabels, 'addToCart', {})
    : null;

  const additionalWarrantyLabel = _.get(additionalPDPLabels, 'warranty.enabled', false)
    ? _.get(additionalPDPLabels, 'warranty', {})
    : null;

  const selectedZone = comunaData?.data || null;
  const defaultZoneConfig =
    selectedZone && !_.isEmpty(selectedZone)
      ? selectedZone
      : {
          region: {},
          comuna: {},
        };

  const [zoneConfig, setZoneConfig] = useState(defaultZoneConfig);

  const renderColorSwatch = () => {
    return (
      <>
        <span>{`${labels.COLOR}: `}</span>
        {colorVariants[selectedColorSwatchIndex] && colorVariants[selectedColorSwatchIndex].label}
        <ProductColorSwatches
          colorVariants={colorVariants}
          productId={product.id}
          selectedColorSwatchIndex={selectedColorSwatchIndex}
          colorSwatchHandler={colorSwatchHandler}
          type={type}
          size="large"
          appCtx={appCtx}
          colorMetrics={colorMetrics}
          variantSwatchType={variantSwatchType}
        />
      </>
    );
  };

  if (isOutOfStock) {
    return (
      <div
        className="product-specifications"
        data-backend-category={product.merchantCategoryId}
        data-availability={product.attributes && product.attributes.isPrimeAvailable}
        data-published={product.isPublished}
        data-variations={variants.length}
      >
        <div className="product-specifications-column">
          {isConnectProduct && renderColorSwatch()}
          <div className={cx(!isMobile && 'flex')}>
            <div>
              {prices && prices.length > 0 && (
                <div className="prices">
                  <ProductPrices
                    isVendorLogin={isVendorLogin}
                    currentTab={currentTab}
                    storeSkuData={storeSkuData}
                    prices={productUtils.getPriceForOutOfStock(prices)}
                    productId={productId}
                    regionCode={regionCode}
                    cmrPoints={cmrPoints}
                    isPumAvailable={isPumAvailable}
                    pumQuantity={pumQuantity}
                    pumUnit={pumUnits}
                    primeShipping={primeShipping}
                    isMobile={isMobile}
                    operators={operators}
                    selectedOperatorId={selectedOperatorId}
                    isConnectProduct={isConnectProduct}
                    handleAddToCart={handleAddToCart}
                  />
                </div>
              )}
              <SellerInfo product={product} />
              {isReaconditionedProd && <ReaconditionedContainer appCtx={appCtx} productAttributes={product} />}
            </div>
          </div>
        </div>
        <style jsx>{ProductSpecificationsMobileStyle}</style>
      </div>
    );
  }
  return (
    <div
      className="product-specifications"
      data-backend-category={product.merchantCategoryId}
      data-availability={product.attributes && product.attributes.isPrimeAvailable}
      data-published={product.isPublished}
      data-variations={variants.length}
    >
      <div className="product-specifications-column">
        {isConnectProduct && renderColorSwatch()}
        <div className={cx(!isMobile && 'flex')}>
          <div>
            {!isSoCom && !isTottusSA && (
              <>
                <SellerInfo product={product} />
                {colorVariants[selectedColorSwatchIndex] && (
                  <div className="color-swatch-container fa--color-swatches__mobile">
                    {!isConnectProduct && renderColorSwatch()}
                  </div>
                )}
                {isConnectProduct && (
                  <Operator
                    operators={operators}
                    operatorChangeHandler={operatorChangeHandler}
                    selectedOperatorId={selectedOperatorId}
                    isConnectProduct={isConnectProduct}
                  />
                )}
                {shouldRenderSize && (
                  <Size
                    title={sizeSelectionLabel}
                    sizes={sizes}
                    onSizeChange={sizeChangeHandler}
                    selectedSize={selectedSize}
                    sizeChartData={sizeChartData}
                    fomo={fomo}
                  />
                )}
              </>
            )}

            {prices && prices.length > 0 && (
              <div className="prices">
                <ProductPrices
                  isVendorLogin={isVendorLogin}
                  currentTab={currentTab}
                  storeSkuData={storeSkuData}
                  prices={prices}
                  productId={productId}
                  regionCode={regionCode}
                  cmrPoints={cmrPoints}
                  isPumAvailable={isPumAvailable}
                  pumQuantity={pumQuantity}
                  pumUnit={pumUnits}
                  primeShipping={primeShipping}
                  isMobile={isMobile}
                  operators={operators}
                  selectedOperatorId={selectedOperatorId}
                  isConnectProduct={isConnectProduct}
                  discountBadge={discountBadge}
                  darSectionActive={darSectionActive}
                  handleAddToCart={handleAddToCart}
                />
              </div>
            )}
            <InstallmentsWithoutInterest
              appCtx={appCtx}
              product={product}
              userSegments={currentUserSegments}
              isUserLoggedIn={isUserLoggedIn}
            />
            {(badges?.length || meatStickers?.length || freeShippingPromotionFor3p?.badge) && (
              <div className="badges">
                <Badges
                  deviceType="mobile"
                  badgeItems={isMeatStickerApplicableInPDP ? nonEventMeatStickers : badges}
                  layout="PDP"
                  isSticker={hasStickers}
                  promotionBadge={freeShippingPromotionFor3p?.badge}
                />
              </div>
            )}
            {isMultipurposeBadgeApplicable && multipurposeBadges.length > 0 && (
              <div className="multipurpose-badge">
                <MultipurposeBadge badgeItems={multipurposeBadges} deviceType="mobile" inPdp />
              </div>
            )}
            <StockQuantity />
            {m2AttributeValue > 0 && isFloorcalculatorEnabled && (
              <div className="floorCalc-pdp-container">
                <FloorCalculator
                  appCtx={appCtx}
                  m2AttributeValue={m2AttributeValue}
                  handleM2QuantityChange={handleM2QuantityChange}
                  handleM2ResultChange={handleM2ResultChange}
                  m2Value={m2Value}
                  m2ResultValue={m2ResultValue}
                  handleM2ValueChange={handleM2ValueChange}
                  isExtraM2Checked={isExtraM2Checked}
                  handleExtraM2Change={handleExtraM2Change}
                />
              </div>
            )}
            {isTottusSA || (isSoCom && <SellerInfo product={product} />)}

            {isInternationalBuyVisiblePDP && isInternationalShipping && <InternationalShipping />}
            {isReaconditionedProd && <ReaconditionedContainer appCtx={appCtx} productAttributes={product} />}
            {addToCartLabel && <AdditionalPDPLabel label={addToCartLabel} type="addToCart" productType="hardline" />}
            <GenericCalculatorContainer handleInputChange={handleInputChange} />
            {(isTottusSA || isSoCom) && (
              <>
                {colorVariants[selectedColorSwatchIndex] && (
                  <div className="color-swatch-container fa--color-swatches__mobile">
                    {!isConnectProduct && renderColorSwatch()}
                  </div>
                )}
                {isConnectProduct && (
                  <Operator
                    operators={operators}
                    operatorChangeHandler={operatorChangeHandler}
                    selectedOperatorId={selectedOperatorId}
                    isConnectProduct={isConnectProduct}
                  />
                )}
                {shouldRenderSize && (
                  <Size
                    title={sizeSelectionLabel}
                    sizes={sizes}
                    onSizeChange={sizeChangeHandler}
                    selectedSize={selectedSize}
                    sizeChartData={sizeChartData}
                    fomo={fomo}
                  />
                )}
              </>
            )}
          </div>
          {isVendorLogin && isStoreDataVaild && (
            <div className="stock-table">
              <StockTable
                stockData={storeSkuData}
                colorVariants={colorVariants}
                selectedColorSwatchIndex={selectedColorSwatchIndex}
                sizes={sizes}
                isMobile={isMobile}
                requestProductFromStore={requestProductFromStore}
                regionCode={regionCode}
              />
            </div>
          )}
        </div>
        {!isConnectProduct && <ProductTopSpecifications scollToElementId="productInfoContainer" />}
        {isTottusSA && Object.keys(availabilityLabels).length > 0 && (
          <ShippingDetails availabilityLabels={availabilityLabels} />
        )}
        <div className="variant-seller-ids">
          <VariantId variantId={currentVariant} labels={labels} isSoCom={isSoCom} />
          {SKUIdSeller({
            appCtx,
            offerings,
            labels,
            regionCode,
            product,
          })}
        </div>
        {addToCartButtonVisible && isVendorLogin && (
          <AddToCartButton
            mobileView
            addToCartButtonVisible={addToCartButtonVisible}
            isAddToCartInProgress={isAddToCartInProgress}
            labels={labels}
            handleAddToCart={handleAddToCart}
            isVendorLogin={isVendorLogin}
            sizes={sizes}
            selectedSize={selectedSize}
            setShowLoginForm={setShowLoginForm}
            showLoginForm={showLoginForm}
            setErrorAddingToCart={setErrorAddingToCart}
            showQuantityError={showQuantityError}
            setQuantityError={setQuantityError}
            inputVal={inputVal}
            setInputVal={setInputVal}
            handleInputChange={handleInputChange}
          />
        )}
        <GetSharedDetails
          sizes={sizes}
          colorVariants={colorVariants}
          regionCode={regionCode}
          store={store}
          is1pSeller={is1pSeller}
          showStoreAvailability={isStoreAvailabilityVisibleInPDP}
          showCollectionButtonVisible={showCollectionButtonVisible}
          handleAddToCart={handleAddToCart}
          comboData={comboData}
          product={product}
          labels={labels}
          showCMRCalculator={isCMRCalculatorEnabledPDP}
          setServiceOption={setServiceOption}
          setWarrantyOption={setWarrantyOption}
          isWarrantyTooltipEnabled={isWarrantyTooltipEnabled}
          additionalWarrantyLabel={additionalWarrantyLabel}
          layout="hardline"
          isSoCom={isSoCom}
          appCtx={appCtx}
          availability={availability}
          sellerName={sellerName}
          currentVariantId={currentVariant}
          darSectionActive={darSectionActive}
          warrantyOptions={warrantyOptions}
          serviceOptions={serviceOptions}
          selectedZone={selectedZone}
          zoneConfig={zoneConfig}
          setZoneConfig={setZoneConfig}
          isDefaultComuna={isDefaultComuna}
        />

        {addToCartButtonVisible && !isVendorLogin && (
          <AddToCartButtonMobile
            maxCartQuantity={maxOnCartAmount}
            labels={labels}
            m2Object={{
              m2AttributeValue,
              m2ResultValue,
              m2Quantity,
              isExtraM2Checked,
              handleM2QuantityChange,
              m2Value,
            }}
            errorAddingToCart={errorAddingToCart}
            isAddToCartInProgress={isAddToCartInProgress}
            handleRemoveFromCart={handleRemoveFromCart}
            isRemoveFromCartInProgress={isRemoveFromCartInProgress}
            appCtx={appCtx}
            handleAddToCart={handleAddToCart}
            showQuantityError={showQuantityError}
            setQuantityError={setQuantityError}
            inputVal={inputVal}
            setInputVal={setInputVal}
            handleInputChange={handleInputChange}
            sizes={sizes}
            selectedSize={selectedSize}
          />
        )}
      </div>
      <style jsx>{ProductSpecificationsMobileStyle}</style>
    </div>
  );
};

ProductSpecificationsMobile.defaultProps = {
  isPumAvailable: false,
  pumQuantity: 0,
  primeShipping: false,
  colorVariants: [],
  selectedColorSwatchIndex: 0,
  colorSwatchHandler: noop,
  sizes: [],
  selectedSize: '',
  sizeChangeHandler: noop,
  handleAddToCart: noop,
  isAddToCartInProgress: false,
  handleRemoveFromCart: noop,
  isRemoveFromCartInProgress: false,
  addToCartButtonVisible: true,
  showCollectionButtonVisible: false,
  operators: [],
  operatorChangeHandler: noop,
  setWarrantyOption: noop,
  setServiceOption: noop,
  requestProductFromStore: noop,
  storeSkuData: {},
  currentTab: '',
  selectedOperatorId: null,
  errorAddingToCart: false,
  handleM2QuantityChange: noop,
  m2Quantity: 1,
  m2ResultValue: 0,
  handleM2ResultChange: noop,
  m2Value: '',
  handleM2ValueChange: noop,
  isExtraM2Checked: true,
  handleExtraM2Change: noop,
  m2AttributeValue: -1,
  showLoginForm: false,
  sizeChartData: {},
  fomo: {},
  userSegments: [],
  isUserLoggedIn: false,
  variantSwatchType: undefined,
};

ProductSpecificationsMobile.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  isPumAvailable: PropTypes.bool,
  pumQuantity: PropTypes.number,
  primeShipping: PropTypes.bool,
  colorVariants: PropTypes.array,
  selectedColorSwatchIndex: PropTypes.number,
  colorSwatchHandler: PropTypes.func,
  sizes: PropTypes.array,
  selectedSize: PropTypes.string,
  sizeChangeHandler: PropTypes.func,
  handleAddToCart: PropTypes.func,
  isAddToCartInProgress: PropTypes.bool,
  handleRemoveFromCart: PropTypes.func,
  isRemoveFromCartInProgress: PropTypes.bool,
  addToCartButtonVisible: PropTypes.bool,
  showCollectionButtonVisible: PropTypes.bool,
  operators: PropTypes.array,
  operatorChangeHandler: PropTypes.func,
  setWarrantyOption: PropTypes.func,
  setServiceOption: PropTypes.func,
  requestProductFromStore: PropTypes.func,
  isVendorLogin: PropTypes.bool.isRequired,
  storeSkuData: PropTypes.object,
  currentTab: PropTypes.string,
  selectedOperatorId: PropTypes.string,
  errorAddingToCart: PropTypes.bool,
  handleM2QuantityChange: PropTypes.func,
  m2Quantity: PropTypes.number,
  m2ResultValue: PropTypes.number,
  handleM2ResultChange: PropTypes.func,
  m2Value: PropTypes.string,
  handleM2ValueChange: PropTypes.func,
  isExtraM2Checked: PropTypes.bool,
  handleExtraM2Change: PropTypes.func,
  m2AttributeValue: PropTypes.number,
  setShowLoginForm: PropTypes.func.isRequired,
  setErrorAddingToCart: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool,
  sizeChartData: PropTypes.object,
  fomo: PropTypes.object,
  userSegments: PropTypes.array,
  isUserLoggedIn: PropTypes.bool,
  variantSwatchType: PropTypes.string,
};

export default withProduct(withLabels(withApplicationContext(withUser(ProductSpecificationsMobile))));
